import { render, staticRenderFns } from "./UiSelectProxy.vue?vue&type=template&id=601c0e49&scoped=true"
import script from "./UiSelectProxy.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiSelectProxy.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601c0e49",
  null
  
)

export default component.exports